export default __webpack_public_path__ + "static/media/sustentabilidade4.0df3da23.jpg";